/**
 * Branch layout — wraps branch-scoped routes (/c/:chapterSlug/b/:branchSlug/*)
 * with a sub-nav. Reads ScopeContext for the resolved branch.
 */

import { NavLink, Outlet } from 'react-router';
import { useScope } from '@/contexts/ScopeContext';

export function BranchLayout() {
  const { chapter, branch, loading, error } = useScope();
  if (loading) return <div className="container mx-auto px-4 py-12 text-white/60">Loading…</div>;
  if (error || !chapter || !branch)
    return <div className="container mx-auto px-4 py-12 text-red-400">{error ?? 'Branch not found'}</div>;

  const base = `/c/${chapter.slug}/b/${branch.slug}`;

  return (
    <div className="min-h-screen flex flex-col">
      <div className="container mx-auto px-4 py-3 border-b border-white/10">
        <div className="flex items-center justify-between flex-wrap gap-2">
          <div>
            <p className="text-xs text-white/40">{chapter.displayName}</p>
            <h1 className="text-lg font-semibold text-white">{branch.displayName ?? branch.name}</h1>
          </div>
          <nav className="flex gap-3 text-sm">
            <Tab to={base} end>Home</Tab>
            <Tab to={`${base}/events`}>Events</Tab>
            <Tab to={`${base}/projects`}>Projects</Tab>
            <Tab to={`${base}/gallery`}>Gallery</Tab>
          </nav>
        </div>
      </div>
      <main className="flex-1">
        <Outlet />
      </main>
    </div>
  );
}

function Tab({ to, end, children }: { to: string; end?: boolean; children: React.ReactNode }) {
  return (
    <NavLink
      to={to}
      end={end}
      className={({ isActive }) =>
        `px-3 py-1.5 rounded transition-colors ${
          isActive ? 'bg-primary/20 text-white' : 'text-white/70 hover:text-white hover:bg-white/5'
        }`
      }
    >
      {children}
    </NavLink>
  );
}

export default BranchLayout;
